import React, { useState, useEffect } from 'react';
import Tooltip from './Tooltip.js'
import AlgoQuickStats from './AlgoQuickStats.js'
import CircularProgress from '@mui/material/CircularProgress';
import { Link } from 'react-router-dom'

function AlgoStatsTooltip(props) {

    const [years, setYears] = useState(props.years !== undefined ? props.years : 5);
    const [stats, setStats] = useState(null);
    const [robustness, setRobustness] = useState(0);
    const [algoType, setAlgoType] = useState("");
    const [isLoading, setIsLoading] = useState(true);
    const [algoInfo, setAlgoInfo] = useState(null);

    useEffect(() => {

    }, [props.algoId]);

    async function loadStats() {
        console.log("Loading stats for algo", props.algoId, years);
        setIsLoading(true);
        let algo = await (await fetch(`/api/algo?algoId=` + props.algoId)).json();
        console.log("algo", algo);
        if (algo && algo.stats)
            setStats(algo.stats);
        if (algo && algo.algo && algo.algo.length) {
            setRobustness(algo.algo[0].robustness_overall)
            setAlgoType(algo.algo[0].algo_type)
            setAlgoInfo(algo.algo[0]);
        }
        setIsLoading(false);
    }

    function getSelectedStats() {
        if (stats && stats.length) {
            let s = stats.find(s => s.years === years)
            return s;
        } else {
            return null;
        }
    }

    let selectedStats = getSelectedStats();

    return (
        <>
            <>
                <Tooltip onOpen={() => loadStats()} textClass={"tooltip-link"} text={"🔍"} width={225} borderWidth={"1px"} position={props.position ? props.position : "right center"} >
                    <center>
                        {isLoading ?
                            <center>
                                <br></br>
                                <CircularProgress />
                            </center>
                            :
                            <>
                                <b>{algoInfo ? algoInfo.trade_symbol : ""}&nbsp;{algoInfo ? algoInfo.display_name : ""}</b>
                                <AlgoQuickStats winningPercentage={selectedStats ? selectedStats.winning_percentage : 0}
                                    avgProfit={selectedStats ? selectedStats.avg_profit : 0}
                                    avgWin={selectedStats ? selectedStats.avg_win : 0}
                                    avgLoss={selectedStats ? selectedStats.avg_loss : 0}
                                    avgDuration={selectedStats ? selectedStats.avg_duration : 0}
                                    robustness={robustness}
                                    cagr={selectedStats ? selectedStats.cagr : 0}
                                    maxDrawdown={selectedStats ? selectedStats.max_drawdown : 0}
                                    algoType={algoType.toUpperCase()}
                                    tradeCount={selectedStats ? selectedStats.count : 0}
                                />
                                <Link onClick={() => setYears(0)} className={years === 0 ? "bold" : ""}>Live</Link>
                                &nbsp;<Link onClick={() => setYears(1)} className={years === 1 ? "bold" : ""}>1Y</Link>
                                &nbsp;<Link onClick={() => setYears(2)} className={years === 2 ? "bold" : ""}>2Y</Link>
                                &nbsp;<Link onClick={() => setYears(3)} className={years === 3 ? "bold" : ""}>3Y</Link>
                                &nbsp;<Link onClick={() => setYears(5)} className={years === 5 ? "bold" : ""}>5Y</Link>
                                &nbsp;<Link onClick={() => setYears(10)} className={years === 10 ? "bold" : ""}>10Y</Link>
                            </>}
                    </center>
                </Tooltip >
            </>
        </>);
}

export default AlgoStatsTooltip;